import { Injectable } from "@angular/core";
import { Action } from "@ngrx/store";
import { ActionWithPayload } from "@obg/ngrx-utils";
import { AppError } from "@obg/ngx.core";

import {
	NotificationsInfo,
	NotificationsInfoRequest,
	OmsMessage,
	OmsMessageStatus,
	OmsUserSettings,
	UpdateMessage,
	UpdateMessagePayload,
	UpdateMessagesPayload,
} from "./oms.model";

const ACTION_PREFIX = "[OMS]";

/**
 * @deprecated - [fabric-deprecated]
 */
export const omsActionType = {
	GET_NOTIFICATIONS_BY_STATUS: `${ACTION_PREFIX} Get Notifications By Status`,
	GET_NOTIFICATIONS_BY_STATUS_SUCCESS: `${ACTION_PREFIX} Get Notifications By Status Success`,
	GET_NOTIFICATIONS_BY_STATUS_ERROR: `${ACTION_PREFIX} Get Notifications By Status Error`,

	UPDATE_MESSAGE: `${ACTION_PREFIX} Update Message`,
	UPDATE_MESSAGE_SUCCESS: `${ACTION_PREFIX} Update Message Success`,
	UPDATE_MESSAGE_ERROR: `${ACTION_PREFIX} Update Message Error`,

	UPDATE_MESSAGES: `${ACTION_PREFIX} Update Messages`,
	UPDATE_MESSAGES_SUCCESS: `${ACTION_PREFIX} Update Messages Success`,
	UPDATE_MESSAGES_ERROR: `${ACTION_PREFIX} Update Messages Error`,

	ENABLE_REALTIME_ALERTS: `${ACTION_PREFIX} Start Alerts Polling`,
	DISABLE_REALTIME_ALERTS: `${ACTION_PREFIX} Stop Alerts Polling`,

	GET_ALERTS: `${ACTION_PREFIX} Get Alerts`,
	GET_ALERTS_SUCCESS: `${ACTION_PREFIX} Get Alerts Success`,
	GET_ALERTS_ERROR: `${ACTION_PREFIX} Get Alerts Error`,

	SET_ALERTS_CONTEXT: `${ACTION_PREFIX} Set Alerts Context`,

	ENABLE_REALTIME_NOTIFICATIONS_INFO: `${ACTION_PREFIX} Start Notifications Info Polling`,
	DISABLE_REALTIME_NOTIFICATIONS_INFO: `${ACTION_PREFIX} Stop Notifications Info Polling`,

	GET_NOTIFICATIONS_INFO: `${ACTION_PREFIX} Get Notifications Info`,
	GET_NOTIFICATIONS_INFO_SUCCESS: `${ACTION_PREFIX} Get Notifications Info Success`,
	GET_NOTIFICATIONS_INFO_ERROR: `${ACTION_PREFIX} Get Notifications Info Error`,

	GET_USER_SETTINGS: `${ACTION_PREFIX} Get User Settings`,
	GET_USER_SETTINGS_SUCCESS: `${ACTION_PREFIX} Get User Settings Success`,
	GET_USER_SETTINGS_ERROR: `${ACTION_PREFIX} Get User Settings Error`,

	UPDATE_USER_SETTINGS: `${ACTION_PREFIX} Update User Settings`,
	UPDATE_USER_SETTINGS_SUCCESS: `${ACTION_PREFIX} Update User Settings Success`,
	UPDATE_USER_SETTINGS_ERROR: `${ACTION_PREFIX} Update User Settings Error`,

	RESET: `${ACTION_PREFIX} Reset`,
};

/**
 * @deprecated - [fabric-deprecated]
 */
@Injectable({
	providedIn: "root",
})
export class OmsAction {
	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetNotificationsByStatus) instead
	 */
	getNotificationsByStatus(payload: OmsMessageStatus): ActionWithPayload {
		return {
			type: omsActionType.GET_NOTIFICATIONS_BY_STATUS,
			payload,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getNotificationsByStatusSuccess(payload: {
		status: OmsMessageStatus;
		notifications: OmsMessage[];
	}): ActionWithPayload {
		return {
			type: omsActionType.GET_NOTIFICATIONS_BY_STATUS_SUCCESS,
			payload,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getNotificationsByStatusError(error: AppError): ActionWithPayload {
		return {
			type: omsActionType.GET_NOTIFICATIONS_BY_STATUS_ERROR,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateMessage) instead
	 */
	updateMessage(
		updateMessage: UpdateMessage,
		messageStatus: OmsMessageStatus
	): ActionWithPayload<UpdateMessagePayload> {
		return {
			type: omsActionType.UPDATE_MESSAGE,
			payload: { message: updateMessage, status: messageStatus },
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	updateMessageSuccess(): Action {
		return {
			type: omsActionType.UPDATE_MESSAGE_SUCCESS,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	updateMessageError(error: AppError): ActionWithPayload {
		return {
			type: omsActionType.UPDATE_MESSAGE_ERROR,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateMessages) instead
	 */
	updateMessages(
		updateMessages: UpdateMessage[],
		messageStatus: OmsMessageStatus
	): ActionWithPayload<UpdateMessagesPayload> {
		return {
			type: omsActionType.UPDATE_MESSAGES,
			payload: { messages: updateMessages, status: messageStatus },
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	updateMessagesSuccess(): Action {
		return {
			type: omsActionType.UPDATE_MESSAGES_SUCCESS,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	updateMessagesError(error: AppError): ActionWithPayload {
		return {
			type: omsActionType.UPDATE_MESSAGES_ERROR,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.PollAlerts) instead
	 */
	alertPollingStart(): Action {
		return {
			type: omsActionType.ENABLE_REALTIME_ALERTS,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	alertPollingStop(): Action {
		return {
			type: omsActionType.DISABLE_REALTIME_ALERTS,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetAlerts)
	 * OR
	 * document.obgEventBus.retrieve(AccountAppValue.PollAlerts) instead
	 */
	getAlerts(): Action {
		return {
			type: omsActionType.GET_ALERTS,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getAlertsSuccess(alerts: OmsMessage[]): ActionWithPayload {
		return {
			type: omsActionType.GET_ALERTS_SUCCESS,
			payload: alerts,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getAlertsError(error: AppError): ActionWithPayload {
		return {
			type: omsActionType.GET_ALERTS_ERROR,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.SetAlertContext) instead
	 */
	setAlertsContext(context: string): ActionWithPayload {
		return {
			type: omsActionType.SET_ALERTS_CONTEXT,
			payload: context,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.PollNotificationsInfo) instead
	 */
	notificationInfoPollingStart(): Action {
		return {
			type: omsActionType.ENABLE_REALTIME_NOTIFICATIONS_INFO,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	notificationInfoPollingStop(): Action {
		return {
			type: omsActionType.DISABLE_REALTIME_NOTIFICATIONS_INFO,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.PollNotificationsInfo)
	 * OR
	 * document.obgEventBus.retrieve(AccountAppValue.GetNotificationsInfo) instead
	 */
	getNotificationsInfo(notificationInfoParams: NotificationsInfoRequest): ActionWithPayload {
		return {
			type: omsActionType.GET_NOTIFICATIONS_INFO,
			payload: notificationInfoParams,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getNotificationsInfoSuccess(notificationsInfo: NotificationsInfo): ActionWithPayload {
		return {
			type: omsActionType.GET_NOTIFICATIONS_INFO_SUCCESS,
			payload: notificationsInfo,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getNotificationsInfoError(error: AppError): ActionWithPayload {
		return {
			type: omsActionType.GET_NOTIFICATIONS_INFO_ERROR,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.retrieve(AccountAppValue.GetOmsUserSettings) instead
	 */
	getUserSettings(): Action {
		return {
			type: omsActionType.GET_USER_SETTINGS,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getUserSettingsSuccess(userSettings: OmsUserSettings): ActionWithPayload {
		return {
			type: omsActionType.GET_USER_SETTINGS_SUCCESS,
			payload: userSettings,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	getUserSettingsError(error: AppError): ActionWithPayload {
		return {
			type: omsActionType.GET_USER_SETTINGS_ERROR,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated] - Use document.obgEventBus.dispatch(AccountAppCommand.UpdateOmsUserSettings) instead
	 */
	updateUserSettings(userSettings: OmsUserSettings): ActionWithPayload {
		return {
			type: omsActionType.UPDATE_USER_SETTINGS,
			payload: userSettings,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	updateUserSettingsSuccess(userSettings: OmsUserSettings): ActionWithPayload {
		return {
			type: omsActionType.UPDATE_USER_SETTINGS_SUCCESS,
			payload: userSettings,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	updateUserSettingsError(error: AppError): ActionWithPayload {
		return {
			type: omsActionType.UPDATE_USER_SETTINGS_ERROR,
			payload: error,
		};
	}

	/**
	 * @deprecated - [fabric-deprecated]
	 */
	reset(): Action {
		return {
			type: omsActionType.RESET,
		};
	}
}
